import { Controller } from '@hotwired/stimulus';

export default class ActiveRadioController extends Controller {
  static targets = [
    'label',
    'input',
  ];

  toggleActiveState(event) {
    const { type } = event.params;

    const inputToCheck = this.inputTargets.find((input) => input.id == `users_profile_type_users${type}profile`);

    inputToCheck.checked = true;

    this.labelTargets.forEach((label) => {
      const labelUserType = label.dataset.activeRadioTypeParam;

      label.classList.toggle('bg-primary-100', labelUserType === type);
    });
  }
}
